/**
 * Showcases Module Configuration
 *
 * Manages public-facing property presentations with analytics.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const showcasesModule: AppModule = {
    id: 'showcases',

    navigation: {
        label: 'Showcases',
        icon: 'presentation',
        path: '/showcases',
        order: 35,
        moduleKey: 'showcases',


        pages: [
            {
                label: 'All Showcases',
                path: '/showcases',
                icon: 'list',
            },
            {
                label: 'Add Showcase',
                path: '/showcases/create',
                icon: 'plus',
            },
            {
                label: 'Analytics',
                path: '/showcases/analytics',
                icon: 'bar-chart',
            },
            {
                label: 'Showcase Map',
                path: '/showcases/map',
                icon: 'map',
            },
        ],
    },

    routes,
}

export default showcasesModule
